/**
 * Appels à l'API SAFE MOUV (Cloud Functions).
 *
 * En production, Firebase Hosting réécrit /api/<nom> vers la fonction du même
 * nom : même origine, donc pas de CORS. En développement, pointez
 * REACT_APP_API_BASE vers l'émulateur, par exemple :
 *   REACT_APP_API_BASE=http://127.0.0.1:5001/safemouv-vtc/europe-west1
 * Les chemins restent identiques dans les deux cas.
 */
const API_BASE = process.env.REACT_APP_API_BASE || "/api";

async function readJsonOrThrow(res) {
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || `Le serveur a répondu ${res.status}.`);
  }
  return data;
}

async function post(endpoint, payload) {
  let res;
  try {
    res = await fetch(`${API_BASE}/${endpoint}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
  } catch (e) {
    throw new Error("Connexion au serveur impossible. Vérifiez votre réseau.");
  }
  return readJsonOrThrow(res);
}

async function get(endpoint, params) {
  const qs = params ? `?${new URLSearchParams(params)}` : "";
  let res;
  try {
    res = await fetch(`${API_BASE}/${endpoint}${qs}`);
  } catch (e) {
    throw new Error("Connexion au serveur impossible. Vérifiez votre réseau.");
  }
  return readJsonOrThrow(res);
}

/** Devis : { distanceKm, durationMin, price, from, to } */
export const fetchQuote = (trip) => post("quote", trip);

/** PaymentIntent : { clientSecret, bookingId, amount } */
export const createPaymentIntent = (trip) => post("createPaymentIntent", trip);

/** Devis enregistré par un chatbot : { id, status, contactName, contactEmail, contactPhone, trip } */
export const fetchLead = (id) => get("lead", { id });

/** Formulaire de contact : notifie SAFE MOUV par email + Telegram. */
export const sendContact = (form) => post("contact", form);
